import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import {
  Button,
  CssBaseline,
  TextField,
  Container,
  Typography,
  Box,
  Paper,
  InputAdornment,
  Input,
  InputLabel,
  IconButton
} from '@mui/material';
import './login.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import * as Yup from 'yup';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { auth } from '../../firebaseConfig';
import { loggedInSuccess } from '../../redux/authSlice';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import CustomButton from '../../components/CustomButton';
import LoginImage from "../../assets/login.png"
import { Visibility, VisibilityOff } from '@mui/icons-material';

function Login() {
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false)
  const from = location.state?.from || "/";
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const theme = createTheme();
  const validateSchema = Yup.object().shape({
    password: Yup.string().min(1),
    email: Yup.string().email('Invalid email').required('Required'),
  });

  useEffect(() => {
    if (token) navigate(from, { replace: true });
  }, [token]);
  const handleClickShowPassword = () => setShowPassword(s => !s)
  const checkIsAdmin = async (email) => {
    try {
      const req = await fetch("https://us-central1-expertminute-net.cloudfunctions.net/api/verifyAdmin", {
        method: "POST",
        body: JSON.stringify({
          email
        })
      })
      const res = await req.json();
      return {
        verified: req.status == 200 || req.status == 201 ? true : false,
        error: null
      }
    } catch (e) {
      return {
        verified: false,
        error: "Something went wrong, please try again later"
      }
    }
  }
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleSubmit = async (values) => {
    try {
      setError("")
      if(!values.password.trim().length) return setError("Please enter a password")
      setLoading(true);
      // await auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      const { verified, error } = await checkIsAdmin(values.email);
      if (error) {
        setError(error)
        setLoading(false);
        return
      }
      if (!verified) {
        setError("Email or password is not correct!");
        setLoading(false)
        return
      }
      const credential = await signInWithEmailAndPassword(auth, values.email, values.password);
      const { user } = credential

      // const user = await firestore.collection('admins').doc(uid).get();

      if (user && user.uid) {
        values.email = '';
        values.password = '';
        setError("")
        dispatch(loggedInSuccess({ token: user.uid }));
        // navigate('/');
        setLoading(false);
      } else {
        setLoading(false);
        throw new Error();
      }
    } catch (e) {
      switch (e.code) {
        case "auth/user-not-found":
          setError("Email or password is not correct!");
          break;
        case "auth/wrong-password":
          setError("Email or password is not correct!");
          break;
        default:
          setError("Somethin went wrong,Please try later!");
          break;
      }
      // 
      setLoading(false);
      // console.log(e.message, "error in signin")
    }
  };
  return (
    // <Paper sx={{maxHeight:"90vh",overflow:"hidden"}}>
    <div className='login-container'>
      <div className='img-container' >
        <img src={LoginImage} height={"100%"}  />
      </div>
      <div className='form-container'>
        <Formik
          initialValues={{
            email: '',
            password: '',
            showPassword: false,
          }}
          onSubmit={handleSubmit}
          validationSchema={validateSchema}
        >
          {({
            handleBlur,
            handleChange,
            values,
            errors,
            handleSubmit,
            touched,
          }) => (
            <ThemeProvider theme={theme}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  width: "100%",
                  // flex:.5
                }}
              >
                <Container
                  component="main"
                  fullWidth={true}
                  sx={{
                    // height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // margin:'auto',
                  }}
                >
                  <Container fullWidth={true}>
                    <Typography sx={{ textAlign: "center" }} component="h2" variant="h4" mb={3}>
                      Welcome To Expert Minute
                    </Typography>
                    <Box component="form" noValidate>
                      <TextField
                        margin="normal"
                        // required
                        fullWidth={true}
                        id="email"
                        placeholder="Email Address"
                        name="email"
                        autoComplete="email"
                        variant="standard"
                        autoFocus
                        onBlur={handleBlur('email')}
                        value={values.email}
                        onChange={handleChange('email')}
                        helperText={errors.email}
                        sx={{
                          '& label.Mui-focused': {
                            color: 'black',
                          },
                          '& .MuiOutlinedInput-root': {
                            '&.Mui-focused fieldset': {
                              borderColor: 'gray',
                            },
                          },
                        }}
                      />
                      {/* <TextField
                            label="Size"
                            id="standard-size-small"
                            defaultValue="Small"
                            size="small"
                            variant="standard"
                          /> */}
                      {/* {<InputLabel htmlFor="standard-adornment-password">Password *</InputLabel>} */}
                      <Input
                        required
                        placeholder='Password'
                        label="Password"
                        type={showPassword ? 'text' : 'password'}
                        value={values.password}
                        onChange={handleChange("password")}
                        sx={{
                          width: "100%",
                          height: 50,

                        }}
                        endAdornment={
                          <InputAdornment position="start">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                      {/* <TextField
                          margin="normal"
                          required
                          fullWidth={true}
                          name="password"
                          label="Password"
                          id="password"
                          type="password"
                          onBlur={handleBlur('password')}
                          autoComplete="current-password"
                          value={values.password}
                          onChange={handleChange('password')}
                          helperText={errors.password}
                          sx={{
                                '& label.Mui-focused': {
                                  color: 'black',
                                },
                                '& .MuiOutlinedInput-root': {      
                                '&.Mui-focused fieldset': {
                                  borderColor: 'gray' ,
                                },
                                },
                              }}
                        /> */}
                      <p
                        style={{ color: 'red', margin: "10px 0px 30px 0px", marginVertical: '10px', height: 10 }}
                      >
                        {error}
                      </p>
                      <Box sx={{ marginTop: '10px', mb: '3px' }}>
                        <CustomButton
                          buttonText={isLoading ? "Loading..." : 'Sign In'}
                          onClick={handleSubmit}
                          bg={"#3980FD"}
                        />
                      </Box>

                    </Box>
                  </Container>
                </Container>
              </div>
            </ThemeProvider>
          )}
        </Formik>

      </div>
    </div>
    // </Paper>

  );
}

export default Login;
